import React from "react";
import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, Link, List, ListItem, Paper, Popover, Typography } from "@mui/material";
import { Filter, ProductMenuItem } from '../../store/productSlice';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useRouter } from "next/router";
import { useParams } from "next/navigation";
import CommonCarouselComponent from "../carousal/common_carousel";
import menuPopoverStyle from './menu_popover.module.scss';

interface MainMenuPopoverData {
  productMenuItem: ProductMenuItem,
}

const MainMenuPopover: React.FC<MainMenuPopoverData> = ({ productMenuItem }) => {
  console.log("---- In MainMenuPopover ----: " + productMenuItem);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [selectedFeature, setSelectedFeature] = React.useState<string | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'main-menu_' + productMenuItem?.name : undefined;

  const router = useRouter()
  const isRoundShape = ["color", "material"].includes(productMenuItem.name);
  const isChickletShape = ["Fabric", "size", "sortBy"].includes(productMenuItem.name);

  // Handle feature selection toggle
  const handleFeatureSelection = (featureName: string) => {
    if (selectedFeature === featureName) {
      setSelectedFeature(null); // Toggle off if already selected
    } else {
      setSelectedFeature(featureName); // Set to the selected feature
    }
  };

  function getLink(type: string, name: string): string {

    if (router.query.vendor == "nestingale") {
      return `/products/${router.query.type}/${type}/${name}`
    } else {
      return `/${router.query.vendor}/products/${router.query.type}/${type}/${name}`
    }
  }

  const createRoundMenuItemsBox = () => {

    return (
      productMenuItem?.items?.map((cardItem: Filter, index: number) => {
        if (cardItem.name === "multicolor") {
          cardItem.image = "https://d221a61rb87vel.cloudfront.net/catalog-assets/icons/multicolor-icon.png";
          cardItem.hexaCode = "";
        }
        const isSelected = selectedFeature === cardItem.name; // Check if feature is selected
        return (
          <Card key={productMenuItem.name + cardItem.name} className='style-class-cards menu-cards style-round-card' elevation={4}
            sx={{ m: 1, maxWidth: "100px", minWidth: '80px', border: isSelected ? '2px solid blue' : 'none' }} onClick={() => handleFeatureSelection(cardItem.name)}>
            <a id={cardItem.id || cardItem.name || cardItem.displayName} href={getLink(productMenuItem.name, cardItem.name)}>
              <Box component='div'>
                <CardContent sx={{ padding: '8px' }}>
                  {
                    cardItem.hexaCode
                      ? <Paper sx={{ height: "64px", width: "64px", borderRadius: "50px", backgroundColor: cardItem.hexaCode }} />
                      : <CardMedia sx={{ borderRadius: "50px", height: "64px", width: "64px" }} image={cardItem.image} />

                  }
                </CardContent>
                <Typography textAlign={"center"} noWrap={true} gutterBottom variant="h6" component="div">
                  {cardItem.displayName || cardItem.name}
                </Typography>
              </Box>
            </a>
          </Card>
        )
      })
    )
  }

  const createImageCardsBox = () => {
    return (
      productMenuItem?.items?.map((cardItem: Filter, index: number) => {
        const isSelected = selectedFeature === cardItem.name;
        return (
          <Card key={productMenuItem.name + cardItem.name} className='style-class-cards menu-cards' elevation={4}
            sx={{ m: 1, minWidth: "200px", maxWidth: "200px", border: isSelected ? '2px solid blue' : 'none' }} onClick={() => handleFeatureSelection(cardItem.name)}>
          
          { cardItem.callback

            ? <Box id={cardItem.id || cardItem.name || cardItem.displayName} component='div'>
                <CardActionArea>
                  <CardContent>
                    <CardMedia
                      sx={{ height: "120px" }}
                      image={cardItem.image}
                      className='slide-image'
                      onClick={() => cardItem.callback ? cardItem.callback(cardItem.name) : getLink(productMenuItem.name, cardItem.name)}
                    />
                  </CardContent>
                  <Typography textAlign={"center"} noWrap={true} gutterBottom variant="h6" component="div">
                    {cardItem.displayName || cardItem.name}
                  </Typography>
                </CardActionArea>
              </Box>
            : <a id={cardItem.id || cardItem.name || cardItem.displayName} href={getLink(productMenuItem.name, cardItem.name)}>
              <Box component='div'>
                <CardContent>
                  <CardMedia
                    sx={{ height: "120px" }}
                    image={cardItem.image}
                    className='slide-image'
                  />
                </CardContent>
                <Typography textAlign={"center"} noWrap={true} gutterBottom variant="h6" component="div">
                  {cardItem.displayName || cardItem.name}
                </Typography>
              </Box>
            </a>
          }
          </Card>
        )
      })
    )
  }


  const createChickletBox = () => {
    return (
      <List className={menuPopoverStyle.chicklet_shape} sx={{ columns: Math.round(productMenuItem?.items.length / 5) }}>
        {
          productMenuItem?.items?.map((cardItem: Filter) => {
            const isSelected = selectedFeature === cardItem.name;
            return (
              <ListItem key={productMenuItem.name + cardItem.name} disablePadding>
                <Link id={cardItem.id || cardItem.name || cardItem.displayName} href={getLink(productMenuItem.name, cardItem.name)} sx={{'&:hover': {color: 'primary.main'}, border: isSelected ? '2px solid blue' : 'none'}}>
                  {/* {cardItem.displayName || cardItem.name} */}
                  <Typography textAlign={"center"} noWrap={true} gutterBottom variant="h6" component="div">
                  {cardItem.displayName || cardItem.name}
                </Typography>
                </Link>
              </ListItem>
            )
          })
        }
      </List>
    )
  }


  return (
    <>
      <Button
        sx={{
          typography: 'subtitle2',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'transparent'
          },
          backgroundColor: 'transparent',
          padding: '0'
        }}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        aria-describedby={id}
      >
        {productMenuItem.displayName}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: 0
          }
        }}
      //hideBackdrop={true}
      >
        <Box component="div" sx={{
          display: 'flex',
          overflowY: 'hidden',
          background: "white",
          border: 1,
          borderRadius: 2,
          paddingTop: '10px',
          paddingBottom: '10px',
          borderColor: (theme: { palette: { secondary: { main: any; }; }; }) => theme.palette.secondary.main
        }}>
          {/* {
            isChickletShape ? (
              <>
                {createChickletBox()}
              </>
            ) : (
              <>
                {
                  isRoundShape ? <CommonCarouselComponent type="scrollable" cards={createRoundMenuItemsBox()} /> : <CommonCarouselComponent type="scrollable" cards={createImageCardsBox()} />
                }
              </>
            )
          } */}
          {isChickletShape ? createChickletBox() : isRoundShape ? <CommonCarouselComponent type="scrollable" cards={createRoundMenuItemsBox()} /> : <CommonCarouselComponent type="scrollable" cards={createImageCardsBox()} />}
        </Box>
      </Popover>
    </>)
}

export default MainMenuPopover;